import { useQuery } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { fetchAssignments } from './api';
import { USE_ASSIGNMENTS_QUERY_KEY } from './constants';

export const useAssignmentsQuery = () => {
  const { token } = useAccessToken();

  return useQuery(
    [USE_ASSIGNMENTS_QUERY_KEY, token],
    () => fetchAssignments(token),
    { enabled: !!token }
  );
};
